/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { createSlice } from "@reduxjs/toolkit";
import JobRoomInitState from "../../../rooms/JobRoom/state"
import { JOB_ROOM } from "../../../rooms/RoomNameConstants";

const initialState = { ...JobRoomInitState };

const jobRoomSlice = createSlice({
    name: JOB_ROOM,
    initialState: initialState,
    reducers: {
        setSelectedJob: (state, action) => {
            state.selectedJob = action.payload
        },
        updateSelectedJobData: (state, action) => {
            const { field, data } = action.payload
            state.selectedJob[field] = data
        },
        setDataChartStartTime: (state, action) => {
            state.dataChartStartTime = action.payload
        },
        setDataChartDuration: (state, action) => {
            state.dataChartDuration = action.payload
        },
        setLastTenRunsChart: (state, action) => {
            state.lastTenRunsChart = action.payload
        },
        setLastTenRunsTable: (state, action) => {
            state.lastTenRunsTable = action.payload
        },
        setLastDefinitionChangesData: (state, action) => {
            state.lastDefinitonChangesData = action.payload
        },
        setLeftPanelSelector: (state, action) => {
            state.leftPanelSelector = action.payload
        },
        setRightPanelSelector: (state, action) => {
            state.rightPanelSelector = action.payload
        },
        setChartTimeSelection: (state, action) => {
            state.chartTimeSelection = action.payload
        },
        setOpenedModal: (state, action) => {
            state.openedModal = action.payload
        },
        resetInitialJobRoom: (state) => {
            Object.assign(state, initialState)
        },
        loadRemoteJobRoom: (state, action) => {
            Object.assign(state, action.payload)
        }
    }
});

export const {
    setLastDefinitionChangesData,
    setChartTimeSelection,
    resetInitialJobRoom,
    updateSelectedJobData,
    setRightPanelSelector,
    setDataChartStartTime,
    setLeftPanelSelector,
    setDataChartDuration,
    setLastTenRunsChart,
    setLastTenRunsTable,
    loadRemoteJobRoom,
    setSelectedJob,
    setOpenedModal,
} = jobRoomSlice.actions;

export default jobRoomSlice;
